export default __webpack_public_path__ + "static/media/examination_branch.af643051.png";